module.exports = __webpack_public_path__ + "media/images/sale_crm/help_desk-9f535df9c310badee4919960f0e8f37b.svg";